import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { useDb } from '../../hooks/useDb';
const TABS = [{
  to: '/beheer/logboek',
  label: 'Logboek'
}, {
  to: '/beheer/huis',
  label: 'Huis'
}, {
  to: '/beheer/systeem',
  label: 'Systeem'
}];
interface BeheerLayoutProps {
  title: string;
  intro: string;
  /** Right side of the page heading: counts, primary actions */
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/** Quiet control room shell shared by Logboek, Huis and Systeem. */
export function BeheerLayout({
  title,
  intro,
  aside,
  children
}: BeheerLayoutProps) {
  const meta = useDb(t => t.meta);
  const allOk = meta.connections.lokaal && meta.connections.internet;
  return <div className="min-h-screen w-full bg-night-950 font-sans text-ink" data-id="element-23" data-mp="2540pokfu3kbi">
      <header className="sticky top-0 z-30 border-b border-white/[0.06] bg-night-950/90 backdrop-blur-xl" data-id="element-24" data-mp="3blnquj4a25x5">
        <div className="mx-auto flex h-16 max-w-[1600px] items-center gap-6 px-6 lg:px-10" data-id="element-25" data-mp="3gjfkbhkkm03g">
          <Link to="/" className="flex items-baseline gap-2 whitespace-nowrap rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60" data-id="element-26" data-mp="1gte1c1a46idn">
            <span className="font-display text-[22px] font-light text-ink" data-id="element-27" data-mp="17sg17u2sqv0c">Anna</span>
            <span className="text-[13px] text-ink-muted" data-id="element-28" data-mp="12uo32ibk6cnp">Beheer</span>
          </Link>
          <nav aria-label="Beheer" className="flex items-center gap-1" data-id="element-29" data-mp="xutb0bg1rh12">
            {TABS.map(t => <NavLink key={t.to} to={t.to} className={({
            isActive
          }) => `whitespace-nowrap rounded-full px-3.5 py-1.5 text-[14px] font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${isActive ? 'bg-white/[0.09] text-ink' : 'text-ink-muted hover:text-ink'}`} data-id="element-30" data-mp="t4l7cad1yklo">
                {t.label}
              </NavLink>)}
          </nav>
          <div className="ml-auto hidden items-center gap-5 text-[13px] md:flex" data-id="element-31" data-mp="ga7qq5a0svm">
            <span className="flex items-center gap-2 whitespace-nowrap text-ink-soft" data-id="element-32" data-mp="5hr54bojxx7g">
              <span className={`h-2 w-2 rounded-full ${allOk ? 'bg-accent' : 'bg-amber'}`} aria-hidden data-id="element-33" data-mp="3nncftjn2lzsg" />
              {allOk ? 'Alles verbonden' : meta.connections.internet ? 'Lokaal gestoord' : 'Internet weg, lokaal werkt'}
            </span>
            <span className="tabular-nums text-ink-muted" data-id="element-34" data-mp="jafoxfgp5kou">{meta.time}</span>
            <Link to="/" className="inline-flex items-center gap-1 whitespace-nowrap text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-35" data-mp="o6xrc8ok16y0">
              Wand <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden data-id="element-36" data-mp="ehe8v44r7f3o" />
            </Link>
            <Link to="/bureau" className="inline-flex items-center gap-1 whitespace-nowrap text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-37" data-mp="1278lplp2p3nx">
              Bureau <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden data-id="element-38" data-mp="16zi8isuw5nlz" />
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1600px] px-6 pb-24 pt-10 lg:px-10" data-id="element-39" data-mp="2mp9aleihq0e4">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-40" data-mp="2mozldt59rx9h">
          <div className="max-w-2xl" data-id="element-41" data-mp="31cucx67jjvkz">
            <h1 className="font-display text-[40px] font-light leading-tight text-ink" data-id="element-42" data-mp="31g02snnzv1hr">{title}</h1>
            <p className="mt-2 text-[16px] leading-relaxed text-ink-soft" data-id="element-43" data-mp="2whf0mip6m7qo">{intro}</p>
          </div>
          {aside}
        </div>
        {children}
      </main>
    </div>;
}